<template>
    <van-popup
        v-model="visibleDialog"
        position="bottom"
        closeable
        close-icon="close"
        @close='onClose'
        :closeOnClickModal='false'
        :round="true"
    >
        <div class="conpon">
            <div class="head f32 col333 textCenter borderBot borderBotLeft0">
                促销
            </div>
            <div class="conponLi">
                <div class="shaky borderBot borderBotLeft0" :class="{'arrow2': item.joinType !== 1}" v-for="item in activityList" :key="item.id">
                    <div class="title4" :class="{'m1': item.activityType === 1, 'm2': item.activityType === 2}">
                        <h3 class="f28 col000" v-if="item.activityType === 1 && item.activityRule === 1">{{ getTitle(item.joinType) }}满{{ item.reachValue }}元减{{ item.activityValue }}元</h3>
                        <h3 class="f28 col000" v-if="item.activityType === 1 && item.activityRule === 2">{{ getTitle(item.joinType) }}每满{{ item.reachValue }}元减{{ item.activityValue }}元</h3>
                        <h3 class="f28 col000" v-if="item.activityType === 2">{{ getTitle(item.joinType) }}全部{{ item.reachValue }}件打{{ item.activityValue }}折</h3>
                        <p class="f24 col666">活动时间：{{ item.effectiveStartDate | formatDate3 }}-{{ item.effectiveEndDate | formatDate3 }}</p>
                    </div>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        activityList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onClose () {
            this.$emit('update:visible')
        }
    }
}
</script>

<style lang="scss" scoped>
    .conpon {
        background: #ffffff;
        .head {
            position: relative;
            height: 108px;
            line-height: 108px;
            padding: 0 24px;
        }
        .conponLi {
            background: #ffffff;
            padding: 0 0 0 32px;
            height: 850px;
            overflow-y: auto;
            .shaky {
                position: relative;
                padding: 32px 0;
                &.arrow2:after {
                    top: 48px;
                }
                .title4 {
                    padding-left: 76px;
                    &.m1::before {
                        position: absolute;
                        top: 38px;
                        left: 0;
                        content: '';
                        width: 56px;
                        height: 28px;
                        background: url('../../../../../assets/img/b2b/m1.png')
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    &.m2::before {
                        position: absolute;
                        top: 38px;
                        left: 0;
                        content: '';
                        width: 56px;
                        height: 28px;
                        background: url('../../../../../assets/img/b2b/m2.png')
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    h3 {
                        margin-bottom: 4px;
                    }
                }
            }
        }
    }
    /deep/ .van-popup__close-icon {
        font-size: 44px;
    }
    /deep/ .van-popup__close-icon--top-right {
        top: 30px;
        right: 30px;
    }
</style>